import React from 'react';
import '../styles/RotatingCarousel.css';
import demoVideo from '../assets/vid1A.mp4'; // Adjust path as needed

import centerImage1 from '../assets/logo12.png'; // Adjust the path as needed



const models = [
  {
    name: '• Design Engineering:',
    description: 'Delivering smart, safe, and energy-efficient electrical design solutions for modern infrastructure and industry.',
  },
  {
    name: '• Equipment Rental:',
    description: 'Reliable, high-performance electric equipment rentals tailored for efficiency, safety, and on-demand power needs.',
  },
  {
    name: '• Transformer Oil Filtration: ',
    description: 'Enhancing transformer performance and lifespan through advanced oil purification and contamination control.',
  },
  {
    name: '• Solar Energy:',
    description: 'Empowering sustainable futures with end-to-end solar energy solutions for homes, businesses, and industries.',
  },
 
  {
    name: '• Skilled Manpower:',
    description: 'Providing reliable, industry-ready skilled manpower to power your projects with precision and productivity.',
  },
   {
    name: '• More Services:',
    description: 'Substation ETC and O&M, equipment rental, and skilled workforce outsourcing.',
  }
];

const RotatingCarousel = () => {
  return (
    <div className="carousel3d-wrapper">
      <div className="carousel3d-left">
        <div className="carousel3d-video-section">
          <video
            src={demoVideo}
            autoPlay
            muted
            loop
            playsInline
            className="carousel3d-video"
          />
        </div>
        <p className="carousel3d-description">
          Acume is a leading electrical services company committed to delivering excellence through innovation, precision, and reliability. With a strong foundation in engineering design and AutoCAD drafting, Acume provides end-to-end solutions tailored to meet diverse project needs. The company also specializes in equipment rental for high-performance tools and machinery, as well as transformer oil filtration services that ensure optimal efficiency and longevity of electrical assets.
        </p>
        <p className="carousel3d-description">
          Acume's expert team handles maintenance with utmost professionalism, minimizing downtime and maximizing safety. Additionally, Acume is at the forefront of solar energy solutions, empowering clients with sustainable and cost-effective power alternatives. Driven by quality and customer satisfaction, Acume stands as a trusted partner in powering the future.

        </p>
        <p className="carousel3d-description">
         At Acume , we believe that top-quality electrical solutions shouldn't come at a premium price. Our commitment to affordability means delivering reliable, safe, and innovative services that meet industry standards—without compromising on quality.
        </p>
      </div>

      <div className="carousel3d-container">
        <div className="carousel-crop">
          <ul className="carousel-list" style={{ '--count': models.length }}>
            {models.map((model, index) => (
              <li
                key={index}
                style={{
                  animationDelay: `calc((var(--rotate-speed) / var(--count)) * -${index}s)`,
                }}
              >
                <div
                  className="carousel-card"
                  style={{
                    animationDelay: `calc((var(--rotate-speed) / var(--count)) * -${index}s)`,
                  }}
                >
                  <a>
                    <span className="carousel-model-name">{model.name}</span>
                    <span className='carousel-model-name1'>{model.description}</span>
                  </a>
                </div>
              </li>
            ))}
          </ul>
          <div className="carousel-circle carousel-circle--large"></div>
          <div className="carousel-circle carousel-circle--medium"></div>
        </div>
        <div className="carousel-mask"></div>
        <div className="carousel-center-circle">
  <img src={centerImage1} alt="Center Visual" className="carousel-center-image" />
</div>
      </div>
    </div>
  );
};

export default RotatingCarousel;
